import { Component, Input, OnInit, inject } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NotificationSettingsService } from "@app/mailmessages/service/notification-settings.service";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { NotificationSettingsType } from "./notification-settings-type.enum";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "notification-settings",
    templateUrl: "./notification-settings.component.html",
    styleUrls: ["./notification-settings.component.scss"],
    standalone: false
})
export class NotificationSettingsComponent implements OnInit {
    private settingsService = inject(NotificationSettingsService);
    private toastr = inject(ToastrService);

    @Input() parentTab: TabModel;
    slackToken: string;

    async ngOnInit() {
        if (!this.parentTab.showLoader) {
            this.parentTab.showLoader = true;
        }

        const settings = await firstValueFrom(this.settingsService.getSettings());

        settings.forEach((setting) => {
            switch (setting.Type) {
                case NotificationSettingsType.SlackToken: // Slack Token
                    this.slackToken = setting.Value;
                    break;
            }
        });

        this.parentTab.showLoader = false;
    }

    async saveSettings() {
        if (!this.parentTab.showLoader) {
            this.parentTab.showLoader = true;
        }

        const settings = [
            {
                Type: NotificationSettingsType.SlackToken,
                Value: this.slackToken,
            },
        ];

        await firstValueFrom(this.settingsService.storeSettings(settings));

        this.toastr.success("Settings saved successfully");
        this.parentTab.showLoader = false;
    }

    async syncAllUsers() {
        await firstValueFrom(this.settingsService.syncAllUsers());
        this.toastr.success("User synced successfully.");
    }
}
